import { ErrorBoundary } from "./ErrorBoundary";
import { File as FileComponent } from "./File";
import { FilePageLayout } from "./FilePageLayout";
import { loader } from "./loader";

export const File = {
  Component: FileComponent,
  ErrorBoundary,
  loader,
  PageLayout: FilePageLayout,
};
